var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29071_17435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50195 1.99609H2.00195C1.73674 1.99609 1.48238 2.10145 1.29485 2.28899C1.10731 2.47652 1.00195 2.73088 1.00195 2.99609V9.99609C1.00195 10.2613 1.10731 10.5157 1.29485 10.7032C1.48238 10.8907 1.73674 10.9961 2.00195 10.9961H9.00195C9.26717 10.9961 9.52152 10.8907 9.70906 10.7032C9.8966 10.5157 10.002 10.2613 10.002 9.99609V6.49609",
    stroke: "white",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25195 1.24816C9.45087 1.04925 9.72065 0.9375 10.002 0.9375C10.2833 0.9375 10.553 1.04925 10.752 1.24816C10.9509 1.44707 11.0626 1.71686 11.0626 1.99816C11.0626 2.27946 10.9509 2.54925 10.752 2.74816L6.00195 7.49816L4.00195 7.99816L4.50195 5.99816L9.25195 1.24816Z",
    stroke: "white",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29071_17435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEditIcon);
export default __webpack_public_path__ + "static/media/white-edit-icon.11ca99ea894b836c8df08c5cba1af7fb.svg";
export { ForwardRef as ReactComponent };